interface ExternalRedirectProps {
  externalUrl: string;
  replace?: boolean;
}

const ExternalRedirect = (props: ExternalRedirectProps) => {
  // TODO: This should probably be wrapped in useEffect?
  props.replace
    ? window.location.replace(props.externalUrl)
    : window.location.assign(props.externalUrl);

  return null;
};

export default ExternalRedirect;
